import { Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type Asset from 'stores/Asset';

import DrawerButton from '../DrawerButton';

export interface RemoveFolderButtonProps {
  asset: Asset;
}

function RemoveFolderButton({ asset }: RemoveFolderButtonProps) {
  const removeFolder = () => {
    void asset.parent?.removeFolder(asset.data.path);
  };

  return (
    <Popconfirm
      disabled={asset.loading}
      cancelText="No"
      okText="Yes"
      onConfirm={removeFolder}
      placement="bottomRight"
      title="Are you sure you want to remove this folder and files inside the folder?"
    >
      <DrawerButton>Remove</DrawerButton>
    </Popconfirm>
  );
}

export default observer(RemoveFolderButton);
